import { render, staticRenderFns } from "./BankInfo.vue?vue&type=template&id=0568577a&scoped=true"
import script from "./BankInfo.vue?vue&type=script&lang=js"
export * from "./BankInfo.vue?vue&type=script&lang=js"
import style0 from "./BankInfo.vue?vue&type=style&index=0&id=0568577a&prod&lang=css"
import style1 from "./BankInfo.vue?vue&type=style&index=1&id=0568577a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0568577a",
  null
  
)

export default component.exports